import type { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when retailer has seen referral reengagement banner *
 */
export const HAS_SEEN_REFERRAL_REENGAGEMENT_BANNER =
  'HAS_SEEN_REFERRAL_REENGAGEMENT_BANNER' as IUserMilestone.RetailerMilestone;
